//============================================================
// appsolut Theme VIENNA - v1.0.0
//============================================================
//
// Based on Otis Kit PRO - v2.0.1 from www.creative-tim.com
//
//============================================================

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby-theme-material-ui';
import Collapse from '@mui/material/Collapse';
import Icon from '@mui/material/Icon';

// Otis Kit PRO components
import StyledBox from '../../../controls/StyledBox';
import StyledTypography from '../../../controls/StyledTypography';

function PortalNavbarDropdown({
  name,
  icon,
  children,
  collapseStatus,
  light,
  href,
  route,
  collapse,
  ...rest
}) {
  const linkComponent = {
    component: 'a',
    href,
    target: '_blank',
    rel: 'noreferrer',
  };

  const routeComponent = {
    component: Link,
    to: route,
  };

  return (
    <>
      <StyledBox
        {...rest}
        mx={1}
        p={1}
        display="flex"
        alignItems="baseline"
        color={light ? 'white' : 'dark'}
        opacity={light ? 1 : 0.6}
        sx={{ cursor: 'pointer', userSelect: 'none' }}
        {...(route && routeComponent)}
        {...(href && linkComponent)}
      >
        {icon && (
          <StyledTypography
            variant="body2"
            lineHeight={1}
            color="inherit"
            sx={{ alignSelf: 'center', '& *': { verticalAlign: 'middle' } }}
          >
            {icon}
          </StyledTypography>
        )}
        <StyledTypography
          variant="button"
          fontWeight="regular"
          textTransform="capitalize"
          color={light ? 'white' : 'dark'}
          sx={{ fontWeight: '100%', ml: 1, mr: 0.25 }}
        >
          {name}
        </StyledTypography>
        {collapse && (
          <StyledTypography variant="body2" color={light ? 'white' : 'dark'} ml="auto">
            <Icon sx={{ fontWeight: 'normal', verticalAlign: 'middle' }}>
              {collapse && 'keyboard_arrow_down'}
            </Icon>
          </StyledTypography>
        )}
      </StyledBox>
      {children && (
        <Collapse in={Boolean(collapseStatus)} timeout={400} unmountOnExit>
          {children}
        </Collapse>
      )}
    </>
  );
}

// Setting default values for the props of PortalNavbarDropdown
PortalNavbarDropdown.defaultProps = {
  children: false,
  collapseStatus: false,
  light: false,
  href: '',
  route: '',
};

// Typechecking props for the PortalNavbarDropdown
PortalNavbarDropdown.propTypes = {
  name: PropTypes.string.isRequired,
  icon: PropTypes.node,
  children: PropTypes.node,
  collapseStatus: PropTypes.bool,
  light: PropTypes.bool,
  href: PropTypes.string,
  route: PropTypes.string,
  collapse: PropTypes.bool.isRequired,
};

export default PortalNavbarDropdown;
